import axios from 'axios'

const notifs = {
  fetch (cb) {
    const promise = axios.get('https://api.psyco.fr/cafe/notifs',
      {
        params: {username: localStorage.getItem('username')},
        headers: {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResults(promise, cb)
  },

  unreadCount (cb) {
    const promise = axios.get('https://api.psyco.fr/cafe/unread-notifs',
      {
        params: {username: localStorage.getItem('username')},
        headers: {'Authorization': 'orbbisyourgod'},
      },
    )
    this.handleResults(promise, cb)
  },

  handleResults(promise, cb) {
    promise.then((resp) => {
      if (resp.data.code && resp.data.code !== 200) {
        cb([])
      }
      else {
        cb(resp.data.data)
      }
    }).catch((error) => cb([]))
  },
}

export default notifs
